<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <input class="search" type="text" [(ngModel)]="search" placeholder="Search by code, name or slug"
                autocomplete="off" />
            <button class="add-btn" type="button" (click)="openAdd()">Add equipment</button>
        </div>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (equipment.length === 0) {
            <p class="state-text">No equipment yet.</p>
        } @else if (filtered.length === 0) {
            <p class="state-text">No equipment matches your search.</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th class="thumb-col"></th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Slug</th>
                            <th class="num-col">Specs</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of filtered; track item.id) {
                            <tr>
                                <td class="thumb-col">
                                    @if (item.image && !imageBroken(item)) {
                                        <span class="thumb-slot">
                                            @if (imagePending(item)) {
                                                <!-- Holds the slot while the signed S3 URL is still in flight. -->
                                                <span class="thumb-skeleton" aria-hidden="true"></span>
                                            }
                                            <img [src]="item.image" [alt]="item.code" class="thumb"
                                                loading="lazy" decoding="async"
                                                [class.is-loaded]="!imagePending(item)"
                                                (load)="onImageLoad(item)" (error)="onImageError(item)" />
                                        </span>
                                    } @else {
                                        <span class="no-thumb" title="No image">—</span>
                                    }
                                </td>
                                <td class="code">{{ item.code }}</td>
                                <td>{{ item.name || '—' }}</td>
                                <td class="slug">{{ item.slug }}</td>
                                <td class="num-col">{{ specCount(item) }}</td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="viewPublic(item)"
                                        title="Open the public page">
                                        <fa-icon [icon]="faUpRightFromSquare"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn" (click)="openEdit(item)" title="Edit">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(item)" title="Delete">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
